module.exports = __webpack_public_path__ + "static/media/circle-view-on.d3d49740.svg";